import React, { Component } from 'react'
import MappingAgeRangeList from '../../../components/MappingAgeRangeList'
import { SearchOptions } from '../../../components/TableHelper'
import { MappingAgeRangeConsumer } from '../../../context/MappingAgeRangeContext'

type MappingAgeRangeProps = {
  history: any,
  permissions: any,

  onLoad?: (searchOptions: SearchOptions) => void
}

export default class MappingAgeRange extends Component<MappingAgeRangeProps> {

  handleOnLoad = (searchOptions: SearchOptions) => {
    if (this.props.onLoad) {
      this.props.onLoad(searchOptions)
    }
  }

  render() {
    const { permissions, history } = this.props

    return (
      <MappingAgeRangeConsumer>
        {({ fetching, mappingAgeRanges, pagination, requestMappingAgeRangeList }) => {

          return <MappingAgeRangeList permissions={permissions} loading={fetching} mappingAgeRanges={mappingAgeRanges} pagination={pagination} history={history} onLoad={this.handleOnLoad} loadMappingAgeRanges={requestMappingAgeRangeList} />
        }}
      </MappingAgeRangeConsumer>
    )
  }
}
